import React from 'react';

import MFormHeaderView from './MFormHeader.view';

type Props = {
  className?: string;
  title?: string;
  headerActions?: JSX.Element | JSX.Element[] | null;
  isFullScreen?: boolean;
  onBack?: () => void;
  onFullScreen?: () => void;
};

const MFormHeader: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFormHeaderView
      className={props.className}
      title={props.title}
      headerActions={props.headerActions}
      isFullScreen={props.isFullScreen}
      onBack={props.onBack}
      onFullScreen={props.onFullScreen}
    >
      {props.children}
    </MFormHeaderView>
  );
};

MFormHeader.displayName = 'MFormHeader';
MFormHeader.defaultProps = {};

export default MFormHeader;
